/* eslint-disable no-unused-vars */
//Application State Handler//

import Vue from "vue";
import Vuex from "vuex";

import { languages, rtlLanguages } from "../translations/translations";
import selectedServiceModule from "./selectedServiceModule";
import nyApi from "../api/nyApi";
import common from "../Utilities/common";


Vue.use(Vuex);

const updateRTLCssClasses = (isRTL) => {
  const menuLists = document.querySelectorAll('.v-menu__content');
  const direction = isRTL ? 'right' : 'left';
  menuLists.forEach(menuList => {
    menuList.style.textAlignment =  direction;
  });
}

const userSelection = {
  state: {
    Language: "en",
    ReservationOption: "",
    PreviousPage: "WelcomePage",
    NavToSelectAllLocationsPage: "",
    NavToSelectDateTimePage: "",
    NavFromSelectServicePage: false,
    DirectNavigation: false,
    Loading: false,
    rtlLanguages: rtlLanguages,
    error: {
      message: "",
      allowRefresh: true,
      allowClose: false,
    },
  },
  mutations: {
    language(state, payload) {
      state.Language = payload.value;
    },
    reservationOption(state, payload) {
      state.ReservationOption = payload.value;
    },
    previousPage(state, payload) {
      state.PreviousPage = payload.value;
    },
    navToSelectAllLocationsPage(state, payload) {
      state.NavToSelectAllLocationsPage = payload.value;
    },
    navToSelectDateTimePage(state, payload) {
      state.NavToSelectDateTimePage = payload.value;
    },
    navFromSelectServicePage(state, payload) {
      state.NavFromSelectServicePage = payload.value;
    },
    directNavigation(state, payload) {
      state.DirectNavigation = payload;
    },
    loading(state, payload) {
      state.Loading = payload;
    },
    setError(state, errorParams) {
      state.error.message = errorParams.message;
      state.error.allowRefresh = errorParams.allowRefresh ?? false;
      state.error.allowClose = errorParams.allowClose ?? false;
    }
  },
  actions: {
    language(context, payload) {
      context.commit("language", payload);
    },
    reservationOption(context, payload) {
      context.commit("reservationOption", payload);
    },
    previousPage(context, payload) {
      context.commit("previousPage", payload);
    },
    navToSelectAllLocationsPage(context, payload) {
      context.commit("navToSelectAllLocationsPage", payload);
    },
    navToSelectDateTimePage(context, payload) {
      context.commit("navToSelectDateTimePage", payload);
    },
    navFromSelectServicePage(context, payload) {
      context.commit("navFromSelectServicePage", payload);
    },
    setDirectNavigation(context, payload) {
      context.commit("directNavigation", payload);
    },
    loading(context, payload) {
      context.commit("loading", payload);
    },
    clearUserSelections(context) {
      context.commit("navToSelectAllLocationsPage", "");
      context.commit("navToSelectDateTimePage", "");
      context.commit("navFromSelectServicePage", false);
    },
    setSystemError(context, errorParams) {
      context.commit("setError", errorParams);
    }
  },
  getters: {
    language(state) {
      return state.Language;
    },
    reservationOption(state) {
      return state.ReservationOption;
    },
    previousPage(state) {
      return state.PreviousPage;
    },
    navToSelectAllLocationsPage(state) {
      return state.NavToSelectAllLocationsPage;
    },
    navToSelectDateTimePage(state) {
      return state.NavToSelectDateTimePage;
    },
    navFromSelectServicePage(state) {
      return state.NavFromSelectServicePage;
    },
    directNavigation(state) {
      return state.DirectNavigation;
    },
    siteText(state) {
      console.log(languages);
      return languages[state.Language];
    },
    loading(state) {
      return state.Loading;
    },
    isRTLLanguage(state) {
      return state.rtlLanguages.some(
        (l) => l === state.Language
      );
    },
    systemError(state) {
      return state.error;
    }
  },
};

const siteData = {
  state: {
    ServiceTypes: [],
    Cities: [],
    Languages: [],
    LanguageDefault: "",
    SessionTimeout: "",
    LanguageSpecificServiceTypes: [],
    TestSiteCode: ""
  },
  mutations: {
    serviceTypes(state, payload) {
      state.ServiceTypes = payload;
    },
    cities(state, payload) {
      state.Cities = payload;
    },
    languages(state, payload) {
      state.Languages = payload;
    },
    languageDefault(state, payload) {
      state.LanguageDefault = payload;
    },
    sessionTimeout(state, payload) {
      state.SessionTimeout = payload;
    },
    langaugeSpecificServiceTypes(state, payload) {
      state.LanguageSpecificServiceTypes = payload;
    },
    testSiteCode(state, payload) {
      state.TestSiteCode = payload;
    }
  },
  actions: {
    serviceTypes(context, payload) {
      context.commit("serviceTypes", payload);
    },
    cities(context, payload) {
      context.commit("cities", payload);
    },
    languages(context, payload) {
      context.commit("languages", payload);
    },
    languageDefault(context, payload) {
      context.commit("languageDefault", payload);
    },
    sessionTimeout(context, payload) {
      context.commit("sessionTimeout", payload);
    },
    async getSiteData(context) {
      try {
        context.dispatch("loading", true);
        const data = await nyApi.GetSiteData();
        context.commit("serviceTypes", data.ServiceTypes);
        context.commit("cities", data.Cities);
        context.commit("languages", data.Languages);
        context.commit(
          "sessionTimeout",
          data.SiteConfigSettings.SessionTimeout
        );
        for (let i = 0; i < data.Languages.length; i += 1) {
          if (data.Languages[i].Default) {
            console.log(data.Languages[i].Name);
            context.commit("languageDefault", data.Languages[i].Code);
            context.commit({
              type: "language",
              value: data.Languages[i].Code,
            });
          }
        }
        console.log(data.ServiceTypes);
        console.log(data.Cities);
        console.log(data.Languages);
      } catch (error) {
        console.log(error);
      } finally {
        context.dispatch("loading", false);
      }
    },
    async getLocaleSpecificServiceTypes(context) {
      try {
        context.dispatch("loading", true);
        const langauge = context.getters.language;
        const langaugeSpecificServiceTypes = await nyApi.GetServiceTypes(
          langauge
        );
        context.commit(
          "langaugeSpecificServiceTypes",
          langaugeSpecificServiceTypes
        );
      } catch (error) {
        console.log(error);
      } finally {
        context.dispatch("loading", false);
      }
    },
    setTestSiteCode(context, payload) {
      context.commit("testSiteCode", payload);
    }
  },
  getters: {
    serviceTypes(state, _, rootState) {
      return rootState.userSelection.Language === "en"
        ? state.ServiceTypes
        : state.LanguageSpecificServiceTypes;
    },
    cities(state) {
      return state.Cities;
    },
    languages(state) {
      return state.Languages;
    },
    languageDefault(state) {
      return state.LanguageDefault;
    },
    sessionTimeout(state) {
      return state.SessionTimeout;
    },
    serviceType: (state, _, rootState) => (typeId) => {
      const serviceTypes =
        rootState.userSelection.Language === "en"
          ? state.ServiceTypes
          : state.LanguageSpecificServiceTypes;

      let serviceType = null;
      if (serviceTypes) {
        serviceTypes.every((element) => {
          serviceType = element.ServiceTypes.find((s) => s.TypeId === typeId);
          let status = serviceType ? false : true;
          return status;
        });
      }
      return serviceType;
    },
    testSiteCode(state) {
      return state.TestSiteCode;
    }
  },
};

const newAppointment = {
  state: {
    City: "",
    Zip: "",
    UserInfo: {},
    LocationId: 0,
    ServiceTypeId1: 0,
    ServiceTypeId2: 0,
    Booking: {},
    AvailableLocations: [],
    AvailableLocationsByCounty: [],
    LocationAvailability: "",
    AllLocations: [],
    AvailableLocationDates: [],
    MoreDatesAvailable: false,
    SelectedLocation: {},
    SelectedTimeSlot: {},
    Reschedule: false,
    DateOfBirth: "",
  },
  mutations: {
    availableLocations(state, payload) {
      state.AvailableLocations = payload;
    },
    availableLocationsByCounty(state, payload) {
      state.AvailableLocationsByCounty = payload;
    },
    selectedLocation(state, payload) {
      state.SelectedLocation = payload;
    },
    availableLocationDates(state, payload) {
      state.AvailableLocationDates = payload;
    },
    moreDatesAvailable(state, payload) {
      state.MoreDatesAvailable = payload;
    },
    city(state, payload) {
      state.City = payload;
    },
    zip(state, payload) {
      state.Zip = payload;
    },
    userInfo(state, payload) {
      state.UserInfo = payload;
    },
    selectedTimeSlot(state, payload) {
      state.SelectedTimeSlot = payload;
    },
    booking(state, payload) {
      state.Booking = payload;
    },
    reschedule(state, payload) {
      state.Reschedule = payload;
    },
    dateOfBirth(state, payload) {
      state.DateOfBirth = payload;
    },
  },
  actions: {
    async getAvailableLocations(context, data) {
      console.log(data);
      try {
        context.dispatch("loading", true);
        const dob = context.getters.dateOfBirth;
        const startDate = common.determineAvailabilityStartDate(
          context,
          null,
          data.serviceTypeId,
          data.serviceTypeId2,
          dob
        );
        const availableLocations = await nyApi.GetAvailbleLocations(
          data.city,
          data.zip,
          data.serviceTypeId,
          data.serviceTypeId2,
          startDate
        );
        console.log(availableLocations);
        context.commit("availableLocations", availableLocations);
        return availableLocations && availableLocations.length > 0;
      } catch (error) {
        console.log(error);
      } finally {
        context.dispatch("loading", false);
      }
    },
    async getLocationsWithServiceType(context, data) {
      const typeId = context.getters["selectedService/selectedServiceTypeId"];
      const typeId2 = context.getters["selectedService/selectedServiceTypeId2"];
      const startDate = common.determineAvailabilityStartDate(
        context,
        null,
        typeId,
        typeId2,
        context.getters.dateOfBirth
      );
      let locations = null;
      try {
        context.dispatch("loading", true);
        locations = await nyApi.GetLocationsWithServiceType(
          data.serviceTypeId,
          data.serviceTypeId2,
          startDate
        );
        console.log(locations);
      } catch (error) {
        console.log(error);
      } finally {
        context.dispatch("loading", false);
      }
      return locations;
    },
    async getLocationsByCountyWithServiceType(context, data) {
      const typeId = context.getters["selectedService/selectedServiceTypeId"];
      const typeId2 = context.getters["selectedService/selectedServiceTypeId2"];
      const startDate = common.determineAvailabilityStartDate(
        context,
        null,
        typeId,
        typeId2,
        context.getters.dateOfBirth
      );
      let locationsByCounty = null;
      try {
        context.dispatch("loading", true);
        locationsByCounty = await nyApi.GetLocationsWithServiceTypeByCounty(
          data.serviceTypeId,
          data.serviceTypeId2,
          startDate
        );
        console.log(locationsByCounty);
      } catch(error) {
        console.log(error);
      } finally {
        context.dispatch("loading", false);
      }
      return locationsByCounty;
    },
    async getLocationByLocationId(context, data) {
      const typeId = context.getters["selectedService/selectedServiceTypeId"];
      const typeId2 = context.getters["selectedService/selectedServiceTypeId2"];
      const startDate = common.determineAvailabilityStartDate(
        context,
        null,
        typeId,
        typeId2,
        context.getters.dateOfBirth
      );
      let locationsByCounty = null;
      try {
        context.dispatch("loading", true);
        locationsByCounty = await nyApi.GetLocationByLocationId(
          data.serviceTypeId,
          data.serviceTypeId2,
          startDate,
          data.locationId
        );
        console.log(locationsByCounty);
      } catch(error) {
        console.log(error);
      } finally {
        context.dispatch("loading", false);
      }
      return locationsByCounty;
    },
    selectLocation(context, data) {
      context.commit("selectedLocation", data);
      context.commit("availableLocationDates", []);
    },
    async getLocationAvailability(context, date) {
      try {
        context.dispatch("loading", true);
        const typeId = context.getters["selectedService/selectedServiceTypeId"];
        const typeId2 =
          context.getters["selectedService/selectedServiceTypeId2"];
        const locationId = context.getters.selectedLocation.Id;
        const startDate = common.determineAvailabilityStartDate(
          context,
          date,
          typeId,
          typeId2,
          context.getters.dateOfBirth
        );
        const locationAvailability = await nyApi.GetLocationAvailability(
          locationId,
          typeId,
          typeId2,
          startDate
        );
        console.log(locationAvailability);
        if (
          locationAvailability &&
          locationAvailability.LocationAvailabilityDates.length > 0
        ) {
          let dates = context.getters.availableLocationDates;
          dates = common.updateLocationAvailability(
            locationId,
            dates,
            locationAvailability
          );
          //dates = dates.concat(locationAvailability.LocationAvailabilityDates);
          context.commit("availableLocationDates", dates);
          context.commit(
            "moreDatesAvailable",
            locationAvailability.MoreDatesAvailable
          );
        }
      } catch (error) {
        console.log(error);
      } finally {
        context.dispatch("loading", false);
      }
    },
    city(context, data) {
      context.commit("city", data);
    },
    zip(context, data) {
      context.commit("zip", data);
    },
    setUserInfo(context, data) {
      context.commit("userInfo", data);
    },
    setTimeSlot(context, data) {
      context.commit("selectedTimeSlot", data);
    },
    async saveBooking(context) {
      //Get Data From Store//
      try {
        context.dispatch("loading", true);
        const g = context.getters;
        const typeId1 = g["selectedService/selectedServiceTypeId"];
        const typeId2 = g["selectedService/selectedServiceTypeId2"];
        const selectedSlot = g.selectedTimeSlot;
        const userInfo = g.userInfo;
        let bookingResult = null;
        if (!g.reschedule) {
          bookingResult = await nyApi.SaveBooking(
            typeId1,
            typeId2,
            selectedSlot.StartDateTime,
            selectedSlot.Duration,
            userInfo.firstName,
            userInfo.lastName,
            userInfo.email,
            common.normalizePhoneNumber(userInfo.phone),
            g.selectedLocation.Id,
            selectedSlot.SlotId,
            g.dateOfBirth
          );
        } else {
          bookingResult = await nyApi.RescheduleBooking(
            typeId1,
            typeId2,
            selectedSlot.StartDateTime,
            selectedSlot.Duration,
            userInfo.firstName,
            userInfo.lastName,
            userInfo.email,
            common.normalizePhoneNumber(userInfo.phone),
            g.selectedLocation.Id,
            selectedSlot.SlotId,
            g.dateOfBirth
          );
        }

        //TODO: Add error checking //
        context.commit("booking", bookingResult.Booking);
        console.log(bookingResult);
        return bookingResult;
      } catch (error) {
        console.log(error);
      } finally {
        context.dispatch("loading", false);
      }
    },
    setReschedule(context, data) {
      context.commit("reschedule", data);
    },
    dateOfBirth(context, data) {
      context.commit("dateOfBirth", data);
    },
    clearNewAppointmentData(context) {
      // context.commit('userInfo', {});
      context.commit("city", "");
      context.commit("zip", "");
      context.commit("reschedule", false);
      context.commit("dateOfBirth", "");
      context.commit("selectedTimeSlot", {});
      context.commit("availableLocations", []);
      context.commit("selectedLocation", {});
      context.commit("availableLocationDates", []);
      context.commit("availableLocationsByCounty",[]);
    },
    setAvailableLocationsByCounty(context, data) {
      context.commit("availableLocationsByCounty", data);
    }
  },
  getters: {
    city(state) {
      return state.City;
    },
    zip(state) {
      return state.Zip;
    },
    availableLocations(state) {
      return state.AvailableLocations;
    },
    selectedLocation(state) {
      return state.SelectedLocation;
    },
    availableLocationDates(state) {
      return state.AvailableLocationDates;
    },
    moreDatesAvailable(state) {
      return state.MoreDatesAvailable;
    },
    userInfo(state) {
      return state.UserInfo;
    },
    selectedTimeSlot(state) {
      return state.SelectedTimeSlot;
    },
    booking(state) {
      return state.Booking;
    },
    maxAvailableDate(state) {
      const availableDates = state.AvailableLocationDates.map((ad) => {
        return new Date(ad.AvailabilityDate.replace("T00:00:00", "T00:00"));
      });
      console.log(availableDates);
      const maxDate = availableDates.slice(-1)[0];
      console.log(maxDate);
      return maxDate;
    },
    minAvailableDate(state) {
      const availableDates = state.AvailableLocationDates.map((ad) => {
        return new Date(ad.AvailabilityDate.replace("T00:00:00", "T00:00"));
      });
      const minDate = availableDates.sort((a, b) => a - b)[0];
      console.log(minDate);
      return minDate;
    },
    reschedule(state) {
      return state.Reschedule;
    },
    dateOfBirth(state) {
      return state.DateOfBirth;
    },
    availableLocationsByCounty(state) {
      return state.AvailableLocationsByCounty;
    }
  },
};

const existingAppoinments = {
  state: {
    Bookings: [],
    Phone: "",
    Email: "",
    ConfirmationNumber: "",
    SelectedBooking: null,
    CancelledBooking: null,
  },
  mutations: {
    bookings(state, payload) {
      state.Bookings = payload;
    },
    phone(state, payload) {
      state.Phone = payload;
    },
    email(state, payload) {
      state.Email = payload;
    },
    confirmationNumber(state, payload) {
      state.ConfirmationNumber = payload;
    },
    selectedBooking(state, payload) {
      state.SelectedBooking = payload;
    },
    cancelledBooking(state, payload) {
      state.CancelBooking = payload;
    },
  },
  actions: {
    async authenticate(context, data) {
      context.dispatch("loading", true);
      const res = await nyApi.LoginUser(
        data.user,
        data.action,
        data.token
      );
     
      if (res?.data?.existingBookings) {
        const bookings = JSON.parse(res.data.existingBookings ?? "[]");
        context.commit("bookings", bookings);
      }
      
      context.commit("selectedBooking", null);
      context.dispatch("loading", false);
      return res;
    },
    async verifyOtp(context, data) {
      context.dispatch("loading", true);
      const res = await nyApi.VerifyOTP(
        data.otp
      );
      context.dispatch("loading", false);
      return res;
    },
    async getExistingBookings(context, data) {
      context.dispatch("loading", true);
      const bookings = await nyApi.GetBooking(
        data.email,
        data.phone,
        data.confirmationNumber,
        data.directNavigation
      );
      context.commit("bookings", bookings);
      context.commit("selectedBooking", null);
      context.dispatch("loading", false);
      return bookings && bookings.length > 0;
    },
    selectBooking(context, data) {
      context.commit("selectedBooking", data);
    },
    async cancelBooking(context, bookingId) {
      try {
        context.dispatch("loading", true);
        const result = await nyApi.CancelBooking(bookingId);
        console.log(result);
        context.commit("cancelledBooking", result);
      } catch (error) {
        console.log(error);
      } finally {
        context.dispatch("loading", false);
      }
    },
    clearExistingAppointmentData(context) {
      context.commit("bookings", []);
      context.commit("selectedBooking", null);
      context.commit("cancelledBooking", null);
      context.commit("phone", "");
      context.commit("email", "");
      context.commit("confirmationNumber", "");
    },
    confirmationNumber(context, payload) {
      context.commit("confirmationNumber", payload);
    },
  },
  getters: {
    bookings(state) {
      return state.Bookings;
    },
    selectedBooking(state) {
      return state.SelectedBooking;
    },
    cancelledBooking(state) {
      return state.CancelBooking;
    },
    confirmationNumber(state) {
      return state.ConfirmationNumber;
    },
  },
};

const mobileCheckIn = {
  state: {
    ReservationNumber: "",
    ViewTicketGuid: "",
  },
  mutations: {
    reservationNumber(state, payload) {
      state.ReservationNumber = payload.value;
    },
    viewTicketGuid(state, payload) {
      state.ViewTicketGuid = payload.value;
    },
  },
  actions: {
    reservationNumber(context, payload) {
      context.commit("reservationNumber", payload);
    },
    viewTicketGuid(context, payload) {
      context.commit("viewTicketGuid", payload);
    },
  },
  getters: {
    reservationNumber(state) {
      return state.ReservationNumber;
    },
    viewTicketGuid(state) {
      return state.ViewTicketGuid;
    },
  },
};

const store = new Vuex.Store({
  modules: {
    userSelection,
    siteData,
    selectedService: selectedServiceModule,
    newAppointment,
    existingAppoinments,
    mobileCheckIn,
  },
});

export default store;
